import { ButtonGroup } from '@material-ui/core';
import styled from 'styled-components';

export const StyledButtonListToggler = styled.div`
  & .MuiButtonBase-root {
    height: 3rem;
    border-radius: 0;
  }
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  display: inline-flex;
  position: relative;

  .MuiButtonGroup-grouped:not(:first-of-type) {
    border-left: none;
  }

  .MuiButtonBase-root {
    &:not(:last-of-type)::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 50%;
      background-color: rgba(0, 0, 0, 0.23);
    }
  }
`;
